import DynamicDropdown from "@eisinc/MobiusOverrides/DynamicDropdown";

export default DynamicDropdown;

export * from "@eisinc/MobiusOverrides/DynamicDropdown";
